module.exports = __webpack_public_path__ + "static/media/storytelling-bg.07cedc9a.svg";